//@flow

import {getRealTimeAuthenticationTokenEndpoint} from '../api';
import type {RealTimeAuthenticationTokenResponse} from '../api';

export function getRealTimeAuthenticationTokenService(): Promise<RealTimeAuthenticationTokenResponse> {
  return getRealTimeAuthenticationTokenEndpoint().toPromise();
}
